export default "__VITE_ASSET__B86h6pDo__";